import { useState, useEffect } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { Header } from '../Header';
import { Sidebar } from '../Sidebar';
import { Footer } from '../Footer';
import { useShowAuthenticatedLayout } from '@/hooks';
import { debug } from '@/utils/debug';

export function Layout() {
  const [devMode, setDevMode] = useState(debug.isDev());
  const showAuthenticatedLayout = useShowAuthenticatedLayout();

  useEffect(() => {
    const unsubscribe = debug.onModeChange(() => {
      setDevMode(debug.isDev());
    });
    return unsubscribe;
  }, []);

  return (
    <div className="min-h-screen flex flex-col pt-[var(--header-h)]">
      {/* Scroll to top on push nav, restore prior position on back/forward. */}
      <ScrollRestoration />
      <Header />
      <div className="flex flex-1 min-h-0">
        {showAuthenticatedLayout && <Sidebar />}
        <main className="flex-1 min-w-0 bg-white">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
            <Outlet />
          </div>
        </main>
      </div>
      <Footer />

      {/* Debug indicator only in development when VITE_SHOW_DEBUG is not false */}
      {devMode && import.meta.env.VITE_SHOW_DEBUG !== 'false' && (
        <div className="fixed bottom-4 right-4 bg-gray-800 text-white px-3 py-1 rounded-md text-xs">
          🔧 Development Mode
        </div>
      )}
    </div>
  );
}
